import { useEffect, useRef } from "react";

export const AdBanner = ({ slot, format = "vertical", className = "" }) => {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
        pushed.current = true;
      }
    } catch (e) {
      // AdSense may not be loaded yet
    }
  }, []);

  const isVertical = format === "vertical";

  return (
    <div
      className={`ad-banner-wrapper ${className}`}
      data-testid={`ad-banner-${format}`}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{
          display: "block",
          width: isVertical ? "160px" : "100%",
          height: isVertical ? "600px" : "auto",
        }}
        data-ad-client="ca-pub-6585219991395423"
        data-ad-slot={slot || "auto"}
        data-ad-format={isVertical ? "vertical" : "auto"}
        data-full-width-responsive={isVertical ? "false" : "true"}
      />
    </div>
  );
};
